/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element

          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Manager from '@/api/Manager';
import store from "@/store/store";
import { canAccess } from '@/acl/roles';
import Vue from 'vue';

const productDocumentsHeader = 'Product Documents';
const claimDocumentsHeader = 'Claims Documents';
const productHeader = 'Products';
const claimsNotificationsHeader = 'Claims Notifications';
const menuItems = [
  {
    url: '/',
    name: 'Dashboard',
    tagColor: 'warning',
    icon: 'home',
  },

  {
    name: 'CRM',
    icon: 'box-open',
    submenu: [
      {
        url: '/companies',
        name: 'Entities',
        icon: 'building',
        slug: 'company.list',
      },
      {
        url: '/contacts',
        name: 'Contacts',
        icon: 'address-card',
        slug: 'contact.list',
      },
      {
        url: '/applications',
        name: 'Applications',
        icon: 'browser',
        slug: 'application.list',
      },
      {
        url: '/roles',
        name: 'Roles',
        icon: 'user-tag',
        slug: 'role.list',
      },
      {
        name: 'Personas',
        icon: 'user-cog',
        submenu: [
          {
            url: '/personas/orion',
            name: 'Orion',
            icon: 'user-cog',
            slug: 'personas.orion.list',
          },
          {
            url: '/personas/fulweb',
            name: 'FulWeb',
            icon: 'user-cog',
            slug: 'personas.fulweb.list',
          },
          {
            url: '/personas/data-centre',
            name: 'Data Centre',
            icon: 'user-cog',
            slug: 'personas.data-centre.list',
          },
          {
            url: '/personas/ipr-platform',
            name: 'IPR Platform',
            icon: 'user-cog',
            slug: 'personas.ipr-platform.list',
          },
          {
            url: '/personas/landing-page',
            name: 'Landing Page',
            icon: 'user-cog',
            slug: 'personas.landing-page.list',
          },
          {
            url: '/personas/learn-dash',
            name: 'Learn Dash',
            icon: 'user-cog',
            slug: 'personas.learn-dash.list',
          },
        ]
      },

    ],
  },
  {
    name: 'Content Management',
    icon: 'folder-open',
    submenu: [
      {
        url: '/content-management/administrators',
        name: 'Administrators',
        icon: 'folder-open',
        slug: 'content-management.administrators.list',
      },
      {
        url: '/content-management/news',
        name: 'News Popups',
        icon: 'folder-open',
        slug: 'content-management.news.list',
      },
      {
        url: '/content-management/nodes',
        name: 'Nodes Managament',
        icon: 'folder-open',
        slug: 'content-management.nodes.list',
      },
    ]
  },
  {
    name: 'Facility Map',
    icon: 'folder-open',
    submenu: [
      {
        url: '/facilities',
        name: 'Facilities',
        icon: 'folder-open',
        slug: 'facilities.list',
      },
    ]
  },
  {
    name: 'Clients Map',
    icon: 'street-view',
    submenu: [
      {
        url: '/client-maps',
        name: 'Client Maps',
        icon: 'street-view',
        slug: 'client-map.list',
      },
    ]
  },
  {
    name: productHeader,
    icon: 'file-spreadsheet',
    submenu: [
      {
        url: '/products',
        name: 'Products',
        icon: 'file',
        slug: 'products.list',
      },
      {
        url: '/commercial-products',
        name: 'Commercial Products',
        icon: 'file-alt',
        slug: 'commercial-products.list',
      },
      {
        url: '/product-bundles',
        name: 'Product Bundles',
        icon: 'file',
        slug: 'product-bundles.list',
      },
      {
        url: '/mapping-renewals',
        name: 'Mapping Renewals',
        icon: 'file-alt',
        slug: 'mapping-renewals.list',
      },
      {
        name: claimsNotificationsHeader,
        icon: 'file-spreadsheet',
        submenu: [
          {
            url: '/claims-notifications/commercial-claims',
            name: 'Commercial Claims',
            icon: 'file-alt',
            slug: 'commercial-claims.list',
          },
        ]
      },
    ]
  },
  {
    name: 'Risk Codes',
    icon: 'stream',
    submenu: [
      {
        url: '/risk-codes',
        name: 'Risk Codes',
        icon: 'stream',
        slug: 'risk-codes.list',
      },
    ]
  },
  {
    name: 'Logs',
    icon: 'clipboard-list',
    submenu: [
      {
        url: '/auth0-logs',
        name: 'Auth0',
        icon: 'shield-check',
        slug: 'log.list',
      },
      {
        url: '/audits',
        name: 'Audit',
        icon: 'abacus',
        slug: 'audit.list',
      },
    ]
  },
  {
    name: 'Reports',
    icon: 'file-chart-line',
    submenu: [
      {
        url: '/usersync',
        name: 'User Sync',
        icon: 'users-medical',
        slug: 'sync.user.list',
      },
      {
        url: '/rolesync',
        name: 'Role Sync',
        icon: 'users-cog',
        slug: 'sync.role.list',
      },
    ]
  },
];

const productDocuments = [
  {
    url: '/product-documents/wording',
    name: 'Wording',
    icon: 'file-plus',
    slug: 'wording.list',
  },
  {
    url: '/product-documents/standard-clause',
    name: 'Standard Clause',
    icon: 'file-plus',
    slug: 'standard-clause.list',
  },
  {
    url: '/product-documents/front-jacket',
    name: 'Front Jacket',
    icon: 'file-plus',
    slug: 'front-jacket.list',
  },
  {
    url: '/product-documents/rear-jacket',
    name: 'Rear Jacket',
    icon: 'file-plus',
    slug: 'rear-jacket.list',
  },
];

const claimsDocuments = [];

if (process.env.VUE_APP_ENVIRONMENT === 'development') {
  const debug = {
    name: 'Debug',
    icon: 'home',

    submenu: [
      {
        url: '/pages/login',
        name: 'Login via Auth0',
        slug: 'pages-login.list',
        target: '_blank'
      },
      {
        url: '/debug',
        name: 'Debug page',
        slug: 'debug.list',
      },
    ],
  };

  menuItems.push(debug);
}

/**
 * Retrieve product dynamics
 * @returns {Promise<*>}
 */
const getProductDocumentMenuItems = async () => {
  const manager = new Manager();
  try {
    const {data} = await manager.productDynamic.getOptions();
    return data.data.map((row) => ({
      url: `/product-documents/${row.id}`,
      name: row.DisplayName || row.Type,
      icon: 'file-plus',
      slug: 'dynamic.list'
    }));
  } catch(e) {
    return [];
  }
};

/**
 * Retrieve claims dynamic
 * @returns {Promise<*>}
 */
const getClaimsDocumentMenuItems = async () => {
  const manager = new Manager();
  try {
    const {data} = await manager.commercialClaims.getDynamicClaimsTypes();
    return data.data.map((row) => ({
      url: `/claims-documents/${row.id}`,
      name: row.Type,
      icon: 'file-plus',
      slug: 'dynamic.list'
    }));
  } catch(e) {
    return [];
  }
};


const hasAccessToMenuItem = (submenuItem) => {
  const navAccessData = store.getters['personas/privileges'];
  const isSystem = store.getters['personas/isSystem'];
  let navAccess;
  const slug = submenuItem.slug.split('.');
  let action = slug[slug.length - 1];
  action = action[0].toUpperCase() + action.substring(1);
  slug.pop();
  const route = slug.join('_')

  if (route.includes('personas')) {
    return isSystem;
  }

  navAccess = navAccessData.find((navAccessItem) => navAccessItem.PageName === route);

  return (navAccess && navAccess[action] && Number(navAccess[action]));
};

export const getMenuItems = async () => {
  const documentMenuItems = await getProductDocumentMenuItems();
  productDocuments.push(...documentMenuItems);
  
  const claimsDocumentMenuItems = await getClaimsDocumentMenuItems();
  claimsDocuments.push(...claimsDocumentMenuItems);

  const filteredMenuItems = menuItems.map((menuItem) => {
    if (menuItem.name === 'Dashboard') {
      return menuItem;
    }

    if (menuItem.submenu) {
      const subMenu = menuItem.submenu;
      menuItem.submenu = subMenu.filter((submenuItem) => {
        if (submenuItem.submenu) {
          const childSubMenu = submenuItem.submenu;
          submenuItem.submenu = childSubMenu.filter((childSubmenuItem) => {
            if (childSubmenuItem.slug) {
              return hasAccessToMenuItem(childSubmenuItem);
            }
          })
        }

        if (submenuItem.slug) {
          return hasAccessToMenuItem(submenuItem);
        }

        return true;
      });
    }

    return menuItem;
  });

  const productDocumentsNavItem = filteredMenuItems.find(({name}) => name === productHeader);

  if (productDocumentsNavItem && productDocumentsNavItem.submenu) {
    // Claims Documents
    const filteredClaimDocuments = claimsDocuments.filter((claimsDocument) =>
      claimsDocument.slug ? hasAccessToMenuItem(claimsDocument) : true);

    if (filteredClaimDocuments.length) {
      const claimDocumentsHeaderNavItem = productDocumentsNavItem.submenu.find(({name}) => name === claimsNotificationsHeader)
      claimDocumentsHeaderNavItem.submenu.push({
        name: claimDocumentsHeader,
        icon: 'file-plus',
        submenu: filteredClaimDocuments,
      });
    }

    // Product Documents
    const filteredProductDocuments = productDocuments.filter((productDocument) =>
      productDocument.slug ? hasAccessToMenuItem(productDocument) : true);

    if (filteredProductDocuments.length) {
      productDocumentsNavItem.submenu.push({
        name: productDocumentsHeader,
        icon: 'file-plus',
        submenu: filteredProductDocuments,
      });
    }
  }

  return filteredMenuItems;
};

export default menuItems;
